import { 
    fieldsNameToRemove, subjectRelatedFields, datecompleteRelatedFields, locationRelatedFields,
} from './constants';

export default function removeFields(form) {
    /**
     * Get related names to given input name
     * @param {String} name 
     */
    const getRelatedFields = (name) => {
        switch (name) {
            case 'tx_news_pi1[search][subject]': {
                return subjectRelatedFields;
            }
            case 'tx_news_pi1[overwriteDemand][datecomplete]': {
                return datecompleteRelatedFields;
            }
            case 'tx_stratismap_location[keyword]': {
                return locationRelatedFields;
            }
            default: return [];
        }
    };

    /**
     * Remove name attribute according to input value
     * @param {String} name 
     * @param {Boolean} ignoreZero 
     */
    const removeNameAttribute = (name, ignoreZero = false) => {
        const field = form.querySelector(`[name="${name}"]`);

        if (field) {
            if ((!ignoreZero && field.value === '0') || field.value === '') {
                field.removeAttribute('name');
            }
        }
    };

    /**
     * Find related fields to target and remove name from it
     */
    fieldsNameToRemove.forEach((field) => {
        const relatedFields = getRelatedFields(field.name);

        removeNameAttribute(field.name, field.ignoreZero);

        relatedFields.forEach(relatedField => removeNameAttribute(relatedField, field.ignoreZero));
    });
}
